module.exports = __webpack_public_path__ + "static/images/arrow-move-left.2BHmYyk.svg";